import { Icon } from '@chakra-ui/react'
import { MdOutlineAccessTime } from 'react-icons/md'

export const TimeIcon = (__css: any) => {
  return (
    <Icon as={MdOutlineAccessTime} w={'20px'} h={'20px'} color={'#778295'} __css={__css}/>
  )
}